import { render } from "./historyApprovalV2.vue?vue&type=template&id=4fbebf5c&scoped=true"
import script from "./historyApprovalV2.vue?vue&type=script&lang=js"
export * from "./historyApprovalV2.vue?vue&type=script&lang=js"

import "./historyApprovalV2.vue?vue&type=style&index=0&id=4fbebf5c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-4fbebf5c"

export default script